import { useCallback, useEffect, useRef } from "react";
export var useDebouncedValidation = function (trigger, delay) {
    if (delay === void 0) { delay = 550; }
    var timeoutRef = useRef(null);
    useEffect(function () {
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    var debouncedTrigger = useCallback(function (name) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            void trigger(name);
        }, delay);
    }, [delay, trigger]);
    return debouncedTrigger;
};
